// extracted by mini-css-extract-plugin
export var container = "_3m-1";
export var editor = "_3m-2";
export var resizable = "_3m-3";
export var wrapper = "_3m-0";